"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _parse = require("parse");

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require("../../utils/Utility");

var Utils = _interopRequireWildcard(_Utility);

var _SpinButton = require("../generic/SpinButton");

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INFO_MESSAGE = "Enter your phone number so that restaurant can contact you regarding your order.";

var EditProfileModal = function (_React$Component) {
    _inherits(EditProfileModal, _React$Component);

    function EditProfileModal(props) {
        _classCallCheck(this, EditProfileModal);

        var _this = _possibleConstructorReturn(this, (EditProfileModal.__proto__ || Object.getPrototypeOf(EditProfileModal)).call(this, props));

        _this.populateUserDetails = function () {
            var currentUser = _parse2.default.User.current();
            var phoneNumber = currentUser.get("phoneNumber");
            var infoMessage = null;

            if (!phoneNumber) {
                infoMessage = INFO_MESSAGE;
            }
            _this.setState({
                name: currentUser.get('name'),
                email: currentUser.get('email'),
                phoneNumber: Utils.formatPhoneNumber(currentUser.get("phoneNumber")),
                infoMessage: infoMessage,
                readOnly: currentUser.get('email') ? true : false
            });
        };

        _this.changeName = function (e) {
            console.log(e.target.value);
            _this.setState({
                name: e.target.value
            });
        };

        _this.changeEmail = function (e) {
            _this.setState({
                email: e.target.value
            });
        };

        _this.handleInput = function (e) {
            // console.log(e);

            // console.log(e.target.value);
            // this is where we'll call the phoneNumberFormatter function
            var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(e.target.value);

            _this.setState({
                phoneNumber: formattedPhoneNumber
            });
        };

        _this.keyDown = function (e) {
            _this.setState({ error: '' });
            if (e.keyCode === 13) {
                _this.submit();
            }
        };

        _this.validateUserDetails = function () {
            return !Utils.isEmpty(_this.state.name) && !Utils.isEmpty(_this.state.email) && !Utils.isEmpty(_this.state.phoneNumber);
        };

        _this.submit = function (e) {
            e.preventDefault();
            if (!_this.validateUserDetails()) {
                _this.setState({
                    error: 'Fields can not be empty!'
                });
                return;
            }

            var phoneNo = Utils.removeNonNumber(_this.state.phoneNumber);

            var sname = _this.state.name.replaceAll(/\s+/g, ' ').trim();

            if (Utils.isEmpty(sname)) {
                _this.setState({
                    error: 'User name is empty.'
                });
                return;
            }

            if (phoneNo.length !== 10) {
                _this.setState({
                    error: "Phone number must be of 10 Digits."
                });
                return;
            }

            Utils.showSpinner();
            var currentUser = _parse2.default.User.current();
            currentUser.set("username", _this.state.email);
            currentUser.set("email", _this.state.email);
            currentUser.set("name", sname);
            // currentUser.set("name", this.state.name.replace(/[^a-zA-Z]/gi,' ').replaceAll(/\s+/g, ' ').trim());
            currentUser.set("phoneNumber", phoneNo);
            currentUser.save().then(function () {
                // console.log("User updated successfully.");
                _this.setState({
                    success: true,
                    infoMessage: null,
                    error: null
                });

                // close the user profile modal
                _this.closeUserProfileModal();
            }, function (error) {
                // check the error and alert the invalid session token
                Utils.checkErrorIsInvalidSessionToken(error, _this.props.history, _this.props.locId, false);
                _this.closeUserProfileModal();
            });
        };

        _this.state = {
            showEditProfile: false,
            name: '',
            email: '',
            phoneNumber: '',
            infoMessage: null,
            readOnly: ''
        };
        return _this;
    }

    _createClass(EditProfileModal, [{
        key: "UNSAFE_componentWillMount",
        value: function UNSAFE_componentWillMount() {
            this.populateUserDetails();
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            $('#editModal').modal('show');
            $("#editModal").on('hidden.bs.modal', function () {
                _this2.props.onHide(false);
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            //hide modal if open while unmounting
            if ($('#editModal').hasClass('show')) {
                // The modal is open, so you can hide it
                $('#editModal').modal('hide');
            }
        }
    }, {
        key: "closeUserProfileModal",
        value: function closeUserProfileModal() {
            Utils.hideSpinner();
            var currentUser = _parse2.default.User.current();

            if (!currentUser.get("phoneNumber")) {
                var history = this.props.history;
                var locId = this.props.locId;
                Utils.logOutAll(history, locId, true);
            }

            //hide bootstrap modal
            $('#editModal').modal('hide');
            this.props.onHide(true);
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                "div",
                {
                    className: "modal fade",
                    id: "editModal",
                    tabIndex: "-1",
                    role: "dialog",
                    "aria-labelledby": "modalLabel",
                    "aria-hidden": "true",
                    "data-keyboard": "false",
                    "data-backdrop": "static"
                },
                _react2.default.createElement(
                    "div",
                    { className: "modal-dialog modal-dialog-centered modal-md", role: "document" },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-content" },
                        _react2.default.createElement(
                            "div",
                            { className: "modal-header" },
                            _react2.default.createElement(
                                "h5",
                                { className: "modal-title", id: "modalLabel" },
                                "Edit profile"
                            ),
                            _react2.default.createElement(
                                "button",
                                { type: "button", className: "close", "data-dismiss": "modal",
                                    "aria-label": "Close" },
                                _react2.default.createElement(
                                    "span",
                                    { "aria-hidden": "true" },
                                    "\xD7"
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "modal-body" },
                            !Utils.isEmpty(this.state.infoMessage) ? _react2.default.createElement(
                                "div",
                                { className: "alert alert-info", role: "alert" },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-exclamation-sign", "aria-hidden": "true" }),
                                _react2.default.createElement(
                                    "span",
                                    { className: "sr-only" },
                                    "Info:"
                                ),
                                this.state.infoMessage
                            ) : null,
                            !Utils.isEmpty(this.state.error) ? _react2.default.createElement(
                                "div",
                                { className: "alert alert-danger", role: "alert" },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-exclamation-sign", "aria-hidden": "true" }),
                                _react2.default.createElement(
                                    "span",
                                    { className: "sr-only" },
                                    "Error:"
                                ),
                                this.state.error
                            ) : null,
                            _react2.default.createElement(
                                "form",
                                { id: "profileform", role: "form", className: "form-horizontal", onSubmit: this.submit },
                                _react2.default.createElement(
                                    "div",
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        "div",
                                        { className: "col-md-12 form-group" },
                                        _react2.default.createElement(
                                            "label",
                                            { className: "form-label", htmlFor: "name" },
                                            "Name"
                                        ),
                                        _react2.default.createElement("input", {
                                            id: "name",
                                            className: "form-control",
                                            placeholder: "Enter Name",
                                            onChange: this.changeName,
                                            value: this.state.name,
                                            title: "Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)",
                                            pattern: "[ a-zA-Z][ a-zA-Z ]+[ a-zA-Z]$",
                                            required: true
                                        })
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        { className: "col-md-12 form-group" },
                                        _react2.default.createElement(
                                            "label",
                                            { className: "form-label", htmlFor: "email" },
                                            "Email id"
                                        ),
                                        _react2.default.createElement("input", {
                                            id: "email",
                                            className: "form-control",
                                            type: "text",
                                            placeholder: "Enter Email id",
                                            onChange: this.changeEmail,
                                            value: this.state.email,
                                            readOnly: this.state.readOnly,
                                            required: true
                                        })
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        {
                                            className: "col-md-12 mb-0 form-group" },
                                        _react2.default.createElement(
                                            "label",
                                            { className: "form-label", htmlFor: "phone" },
                                            "Phone number"
                                        ),
                                        _react2.default.createElement("input", {
                                            id: "phone",
                                            className: "form-control",
                                            type: "tel",
                                            ref: "phone",
                                            placeholder: "Enter Phone number",
                                            onChange: function onChange(e) {
                                                return _this3.handleInput(e);
                                            },
                                            value: this.state.phoneNumber,
                                            required: true
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "modal-footer" },
                            _react2.default.createElement(_SpinButton2.default, {
                                classNames: "d-flex swal2-confirm font-weight-bold ft-14  w-50 text-center justify-content-center btn custom-btn-outline-primary",
                                buttonText: "CANCEL",
                                spinText: "",
                                showSpinner: false,
                                "data-dismiss": "modal",
                                showIcon: false,
                                iconClass: ""
                            }),
                            _react2.default.createElement(_SpinButton2.default, {
                                classNames: "btn btn-styl ft-14 font-weight-bold w-50 text-center justify-content-center}",
                                buttonText: "UPDATE",
                                spinText: "",
                                showSpinner: false,
                                whenClicked: this.submit,
                                showIcon: false,
                                iconClass: ""
                            })
                        )
                    )
                )
            );
        }
    }]);

    return EditProfileModal;
}(_react2.default.Component);

exports.default = EditProfileModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/EditProfileModal.jsx
// module id = 560
// module chunks = 0